<div class="message message--user">
  <div class="content">
    {{ message.content }}
  </div>
</div>